import { TriangleAlert } from 'lucide-react';
import { EmptyState } from '@/components/EmptyState';

export function NotFound() {
  return <EmptyState id="notFound" icon={TriangleAlert} />;
}
